module.exports = __webpack_public_path__ + "static/media/saas_videoplaceholder.d200234d.png";